import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useSurveyDashborad() {
  const { fetchQueryDisplayDashboard } = surveyModel();

  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const { openModal, closeModal } = useModal();

  const dynamicDashboard = reactive({
    structure: {},
    dynamicConfig: {
      cardId: null,
      quizGroupId: null,
      questionId: null,
      key: null,
    },
    Survey_GroupId: null,
    name: null,
    desc: null,
  });

  const fetchDashboardDisplay = (Survey_GoupId) => {
    fetchQueryDisplayDashboard.payload.Survey_GroupId = Survey_GoupId;

    store
      .dispatch("api/apiRequest", fetchQueryDisplayDashboard)
      .then((response) => {
        dynamicDashboard.structure = response.data.layoutstructure;
        dynamicDashboard.name = response.data.info.name_html;
        dynamicDashboard.desc = response.data.info.desc_html;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {});
  };

  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };

  onBeforeMount(() => {
    dynamicDashboard.Survey_GroupId = parseInt(router.currentRoute.params.ref);
    fetchDashboardDisplay(dynamicDashboard.Survey_GroupId);
  });

  return { dynamicDashboard, modalPopup, onOpenExportModal, closeReportModal };
}
